import { StatusVariant } from '@factorialco/f0-react'
import { TasksValueObjectsTaskStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const getStatusLabel = (taskStatus: TasksValueObjectsTaskStatusEnum): string => {
  switch (taskStatus) {
    case 'todo':
      return i18n.t('tasks.status.todo')
    case 'in_progress':
      return i18n.t('tasks.status.in_progress')
    case 'done':
      return i18n.t('tasks.status.done')
    case 'discarded':
      return i18n.t('tasks.status.discarded')
  }
}

export const getStatusColor = (taskStatus: TasksValueObjectsTaskStatusEnum): StatusVariant => {
  switch (taskStatus) {
    case 'todo':
      return 'neutral'
    case 'in_progress':
      return 'info'
    case 'done':
      return 'positive'
    case 'discarded':
      return 'warning'
  }
}
